document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('[data-wine-list-modal]');
    const url = modal.getAttribute('data-wine-list-url');
    const altText = modal.getAttribute('data-wine-list-alt') || 'Venue Menu';
    const cleanUrl = url.split('?')[0];
    const fileExtension = cleanUrl.split('.').pop().toLowerCase();
    const container = document.getElementById('documentContainer');

    // Initialize controls
    let currentPage = 1;
    let totalPages = 1;
    let currentScale = 1.0;
    let pdfDocument = null;
    let pageElements = [];

    const scrollUpBtn = document.getElementById('scrollUpBtn');
    const currentPageBtn = document.getElementById('currentPageBtn');
    const scrollDownBtn = document.getElementById('scrollDownBtn');
    const zoomOutBtn = document.getElementById('zoomOutBtn');
    const zoomInBtn = document.getElementById('zoomInBtn');

    // For PDFs
    if (fileExtension.includes('pdf')) {
        pdfjsLib.getDocument(url).promise.then(pdf => {
            pdfDocument = pdf;
            totalPages = pdf.numPages;
            container.innerHTML = ''; // Clear existing canvas

            // Create and render all pages
            const renderPromises = [];
            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                const pageDiv = document.createElement('div');
                pageDiv.className = 'wine-list-page-canvas';
                pageDiv.dataset.page = pageNum;

                const pageLabel = document.createElement('div');
                pageLabel.className = 'wine-list-page-number';
                pageLabel.textContent = `${pageNum} / ${totalPages}`;

                container.appendChild(pageDiv);
                pageDiv.appendChild(pageLabel);
                pageElements.push(pageDiv);

                renderPromises.push(renderPageToDiv(pageNum, pageDiv));
            }

            Promise.all(renderPromises).then(() => {
                setupIntersectionObserver();
            });
        });
    }
    // For images
    else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
        container.innerHTML = ''; // Clear existing canvas
        const imgDiv = document.createElement('div');
        imgDiv.className = 'wine-list-page-canvas';

        const img = document.createElement('img');
        img.src = url;
        img.style.maxWidth = '100%';
        img.alt = altText;
        img.style.height = 'auto';

        imgDiv.appendChild(img);
        container.appendChild(imgDiv);
        pageElements.push(imgDiv);

        // Hide page navigation for single images
        scrollUpBtn.style.display = 'none';
        scrollDownBtn.style.display = 'none';
        currentPageBtn.style.display = 'none';

        // Set total pages to 1 for images
        totalPages = 1;
        
      
    }

    // Render a PDF page to a specific div
    function renderPageToDiv(pageNumber, targetDiv) {
        return pdfDocument.getPage(pageNumber).then(page => {
            // Get device pixel ratio for high-DPI displays
            const devicePixelRatio = window.devicePixelRatio || 1;
            
            // Calculate the scale to make the PDF look crisp
            const baseScale = 1.0;
            const scale = baseScale * devicePixelRatio;
            
            const viewport = page.getViewport({ scale: scale });

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            
            // Set canvas size accounting for device pixel ratio
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            
            // Set CSS size to maintain visual size while keeping high resolution
            canvas.style.height = (viewport.height / devicePixelRatio) + 'px';
            canvas.style.width = (viewport.width / devicePixelRatio) + 'px';
            
            canvas.dataset.page = pageNumber;
            canvas.setAttribute('aria-label', `${altText} - Page ${pageNumber} of ${totalPages}`);


            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };

            // Clear target div and append canvas
            while (targetDiv.firstChild) {
                if (targetDiv.lastChild.className === 'wine-list-page-number') {
                    break;
                }
                targetDiv.removeChild(targetDiv.lastChild);
            }

            targetDiv.insertBefore(canvas, targetDiv.firstChild);
            return page.render(renderContext).promise;
        });
    }

    // Set up intersection observer to track which page is visible
    function setupIntersectionObserver() {
        const options = {
            root: container,
            rootMargin: '0px',
            threshold: 0.5
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const pageNum = parseInt(entry.target.dataset.page);
                    currentPage = pageNum;
                    currentPageBtn.textContent = pageNum;
                }
            });
        }, options);

        pageElements.forEach(pageEl => {
            observer.observe(pageEl);
        });
    }

    // Scroll to specific page
    function scrollToPage(pageNum) {
        if (pageNum < 1 || pageNum > totalPages) return;

        const targetElement = pageElements[pageNum - 1];
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    // Apply zoom to all canvases or images
    function applyZoom() {
        const elements = container.querySelectorAll('canvas, img');
        elements.forEach(element => {
            element.style.transform = `scale(${currentScale})`;
            element.style.transformOrigin = 'center top';
            element.style.transition = 'transform 0.2s ease-in-out';
        });
    }

    // Event listeners for controls
    scrollUpBtn.addEventListener('click', function () {
        if (currentPage > 1) {
            scrollToPage(currentPage - 1);
        }
    });

    scrollDownBtn.addEventListener('click', function () {
        if (currentPage < totalPages) {
            scrollToPage(currentPage + 1);
        }
    });

    zoomOutBtn.addEventListener('click', function () {
        currentScale = Math.max(1.0, currentScale - 0.1); // Changed minimum scale to 1.0
        applyZoom();
    });

    zoomInBtn.addEventListener('click', function () {
        currentScale = Math.min(2.0, currentScale + 0.1);
        applyZoom();
    });

    // Toggle modal
    const triggers = document.querySelectorAll('[data-wine-list-trigger]');
    const closeButtons = document.querySelectorAll('[data-wine-list-close]');

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            modal.classList.add('is-active');
            document.body.classList.add('modal-open');
        });
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', function () {
            modal.classList.remove('is-active');
            document.body.classList.remove('modal-open');
        });
    });

   
});